module.exports = __webpack_public_path__ + "img/NormalSeat_SummerYellow.46df8ecd.png";